import React from "react";
import useStringParam from "@tiny/components/src/hooks/useStringParam";
import { AudienceEventType } from "./AudienceDetails.types";
import { ThemeColor } from "@tiny/components/src/theme/createTheme";
import { PaletteColor } from "@mui/material/styles";
import { useTheme } from "@mui/material";

function useAudienceDetails() {
  const [audienceEventType, setAudienceEventType] =
    useStringParam<AudienceEventType>("eventType", "UNIQUE_CLICK");

  return {
    audienceEventType,
    setAudienceEventType,
  };
}

const colorVariants = ["light", "main", "dark"] as (keyof PaletteColor)[];

function useColorAccessor() {
  const theme = useTheme();
  return React.useCallback(
    (item: any, index?: number) => {
      const colorsArr = Object.keys(theme.palette) as unknown as ThemeColor[];
      const allColors = colorsArr
        .map((color: ThemeColor) => {
          return colorVariants
            .map((variant) => theme.palette[color][variant])
            .filter((variant) => !!variant);
        })
        .flat();

      return allColors[Math.floor((index ?? 0) % allColors.length)] ?? "";
    },
    [theme]
  );
}

export { useColorAccessor, useAudienceDetails };
